import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "./lib/auth";
import PublicLayout from "./components/site/PublicLayout";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Quotazioni from "./pages/Quotazioni";
import Servizi from "./pages/Servizi";
import ChiSiamo from "./pages/ChiSiamo";
import Recensioni from "./pages/Recensioni";
import FAQ from "./pages/FAQ";
import Contatti from "./pages/Contatti";
import Privacy from "./pages/Privacy";
import Cookie from "./pages/Cookie";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminQuotazioni from "./pages/admin/AdminQuotazioni";
import AdminRecensioni from "./pages/admin/AdminRecensioni";
import AdminContatti from "./pages/admin/AdminContatti";
import AdminBanner from "./pages/admin/AdminBanner";
import AdminContenuti from "./pages/admin/AdminContenuti";
import AdminFAQ from "./pages/admin/AdminFAQ";
import AdminSEO from "./pages/admin/AdminSEO";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#15263f", border: "1px solid rgba(212,175,55,0.3)", color: "#fff" } }} />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/quotazioni" element={<Quotazioni />} />
              <Route path="/servizi" element={<Servizi />} />
              <Route path="/chi-siamo" element={<ChiSiamo />} />
              <Route path="/recensioni" element={<Recensioni />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cookie" element={<Cookie />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="quotazioni" element={<AdminQuotazioni />} />
              <Route path="recensioni" element={<AdminRecensioni />} />
              <Route path="contatti" element={<AdminContatti />} />
              <Route path="banner" element={<AdminBanner />} />
              <Route path="contenuti" element={<AdminContenuti />} />
              <Route path="faq" element={<AdminFAQ />} />
              <Route path="seo" element={<AdminSEO />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
